export const XIN_YUE_CHANNEL = '10030476'; //  心悦渠道号
export const SPARK_CHANNEL = '10058448'; //  闪现渠道号
export const BB_CHANNEL = '10053534'; //  助手渠道号
export const GBOT_CHANNEL = '10058447'; //  知几渠道号
export const TGCLUB = 'TGCLUB';
export const SPARK = 'SPARK';
export const BB = 'BB';
export const GBOT = 'GBOT';
export const H5 = 'H5';
// #######################心悦下载状态码
export const STATUS_ON_UN_DOWNLOAD = 0; // 未启动下载
export const STATUS_ON_WAITING = 1; // 等待下载
export const STATUS_ON_DOWNLOADING = 2; // 下载中状态
export const STATUS_ON_PAUSE = 3; // 暂停
export const STATUS_ON_FINISH = 4; // 完成
export const STATUS_ON_FAIL = 5; //  下载失败
export const STATUS_ON_CANCEL = 6; // 取消下载
export const STATUS_ON_INSTALL = 99; // 安装完成
// #######################心悦下载状态码

// #######################闪现下载状态文本
export const SPARK_APP_STATUS_PROGRESS = 'progress';// 下载中
export const SPARK_APP_STATUS_WAIT = 'wait'; // 等待下载中
export const SPARK_APP_STATUS_PAUSE = 'pause'; // 暂停下载
export const SPARK_APP_STATUS_INSTALL = 'install'; //  已经下载完成准备安装
export const SPARK_APP_STATUS_FINISH = 'finish'; // 完成安装
export const SPARK_APP_STATUS_UN_DOWNLOAD = 'undownload'; // 未开始下载
// #######################闪现下载状态文本

//  0=下载，1=暂停
export const SPARK_APP_START_DOWNLOAD_CODE = 0;
export const SPARK_APP_PAUSE_DOWNLOAD_CODE = 1;

// view 更新时间频率 节流防页面抖动 （毫秒）
export const UPDATE_PROCESS_TIME_AWAIT = 400;

// 下载方式
export const IOS_APP_JUMP_APPSTORE = 1; // App跳appstore
export  const IOS_H5_JUMP_APP_STORE = 2; // H5跳appstore
export const ANDROID_APP_DOWNLOAD_APK = 1; // 安卓app内飞鹰下载
export const ANDROID_H5_DOWNLOAD_APK = 2; // 安卓H5直接apk包下载

export default {
  XIN_YUE_CHANNEL,
  SPARK_CHANNEL,
  BB_CHANNEL,
  STATUS_ON_WAITING,
  STATUS_ON_DOWNLOADING,
  STATUS_ON_UN_DOWNLOAD,
  STATUS_ON_PAUSE,
  STATUS_ON_FINISH,
  STATUS_ON_FAIL,
  STATUS_ON_CANCEL,
  STATUS_ON_INSTALL,
  UPDATE_PROCESS_TIME_AWAIT,
  TGCLUB,
  SPARK,
  BB,
  IOS_APP_JUMP_APPSTORE,
  ANDROID_APP_DOWNLOAD_APK,
  ANDROID_H5_DOWNLOAD_APK,
  SPARK_APP_STATUS_PROGRESS,
  SPARK_APP_STATUS_WAIT,
  SPARK_APP_STATUS_PAUSE,
  SPARK_APP_STATUS_INSTALL,
  SPARK_APP_STATUS_FINISH,
  SPARK_APP_STATUS_UN_DOWNLOAD,
};
